import useClipboard from 'vue-clipboard3'

export default defineNuxtPlugin((nuxtApp) => {
  const { toClipboard } = useClipboard()
  return {
    provide: {
      copyText: toClipboard
    }
  }
})